import { render, staticRenderFns } from "./message-list-container.vue?vue&type=template&id=74cddd72"
import script from "./message-list-container.vue?vue&type=script&lang=js"
export * from "./message-list-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports